import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { FileEnums, TableEnums } from "models/enums";
import { FileProfileInfo } from "models/propTypes/userProfilePropTypes";
import { WintSuperkollAPIModel as ApiModels, WintUtilsWebApi } from "wint-api-client/dist/types";
import { SalarySpecificationListViewProps } from "models/propTypes/salaryDeviationPropTypes";
import { DateConstants } from "utils/constants";
//#endregion
//#region components
import { TableAsync } from "components/common";
import { useSalaryDeviationsService } from "serviceHooks";
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
//#endregion

const SalarySpecificationsListView: React.FC<SalarySpecificationListViewProps> = (props) => {
  const salaryDeviationsService = useSalaryDeviationsService();
  const filterFunc = React.useCallback(
    props.useExtendedFilter
      ? (baseFilter: ApiModels.SalarySpecificationsFilter) => {
          baseFilter.personId = props.salarySpecificationUser?.id;
          baseFilter.year = props.year;
          return salaryDeviationsService.getSalarySpecificationsForUser(baseFilter);
        }
      : (baseFilter: WintUtilsWebApi.Filter) => salaryDeviationsService.getSalarySpecifications(baseFilter),
    [props.salarySpecificationUser?.id, props.useExtendedFilter, props.year]
  );

  const onRowClicked = (row: ApiModels.SalarySpecificationDocumentDescriptor) => {
    salaryDeviationsService.downloadSalarySpecification(row.id);
  };

  return (
    <TableAsync<ApiModels.SalarySpecificationDocumentDescriptor>
      tableId={TableEnums.TableType.SalarySpecificationsDocumentList}
      properties={{
        fileName: {
          description: TranslationKeys.Salary.SalarySpecification,
          formatter: (document: ApiModels.SalarySpecificationDocumentDescriptor) =>
            new FileProfileInfo(document.fileName ?? "", FileEnums.ContentTypes.ApplicationPDF.toString()),
          noWrap: true,
        },
        monthDb: {
          description: TranslationKeys.Common.Period,
          formatter: (document: ApiModels.SalarySpecificationDocumentDescriptor) =>
            document.monthDb
              ? LocalizationHelperInstance.getFormattedDate(
                  DateHelper.getDateFromYearMonth(document.monthDb),
                  DateConstants.MonthYearShortConfig
                )
              : "",
          noWrap: true,
          width: 100,
          classification: "date",
        },
      }}
      filter={
        !props.useExtendedFilter
          ? filterFunc
          : props.useExtendedFilter && props.salarySpecificationUser?.id
            ? filterFunc
            : []
      }
      rowClickHandler={onRowClicked}
      maxRowCount={10}
      hidePaginationIfSinglePage
      pagination="advanced"
      orderByProperty="monthDb"
      orderByDescending
    />
  );
};

export default SalarySpecificationsListView;
